import { render, staticRenderFns } from "./Votacao.vue?vue&type=template&id=addef77e&scoped=true&"
import script from "./Votacao.vue?vue&type=script&lang=js&"
export * from "./Votacao.vue?vue&type=script&lang=js&"
import style0 from "./Votacao.vue?vue&type=style&index=0&id=addef77e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addef77e",
  null
  
)

export default component.exports